import type { OptionValue, Product } from './types'

const eurFormatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' })
export const eur = (n: number) => eurFormatter.format(n || 0)
export const VAT = 0.2
export const ttc = (ht: number) => ht * (1 + VAT)
export const frDate = (iso: string) => new Date(iso).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })

// Images hébergées avec le site : 'photo:handball' -> /assets/img/photos/handball-400|700|1000.webp
// Photos envoyées depuis l'admin : /api/images/… -> version réduite ?w=400|700|1000
export const imageUrl = (id = '', w = 800) =>
  id.startsWith('photo:') ? `/assets/img/photos/${id.slice(6)}-${w <= 500 ? 400 : w <= 750 ? 700 : 1000}.webp` : id.startsWith('/api/images/') && !/\.(gif|pdf)$/i.test(id) ? `${id}?w=${w <= 500 ? 400 : w <= 750 ? 700 : 1000}` : id.startsWith('http') || id.startsWith('/') ? id : `/${id}`
export const imageFit = (id = '') => (/\.svg$/i.test(id) ? 'object-contain' : 'object-cover')

export const inkOn = (hex = '#000000') => {
  // Texte blanc seulement si le contraste WCAG atteint 4,5:1, sinon texte foncé
  const [r, g, b] = (hex.replace('#', '').match(/../g) || ['00', '00', '00']).map((x) => { const c = parseInt(x, 16) / 255; return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4 })
  const lum = 0.2126 * r + 0.7152 * g + 0.0722 * b
  return 1.05 / (lum + 0.05) >= 4.5 ? '#ffffff' : '#0f172a'
}

export const optionValue = (v: string | OptionValue): OptionValue => (typeof v === 'string' ? { label: v } : v)
export const defaultVariant = (p: Product) => Object.fromEntries(p.options.map((o) => [o.name, optionValue(o.values[0]).label]))

function variantField(p: Product, variant: Record<string, string>, key: 'priceHT' | 'image') {
  let found: number | string | undefined
  for (const o of p.options) {
    const v = o.values.map(optionValue).find((x) => x.label === variant[o.name])
    if (v?.[key] != null) found = v[key]
  }
  return found
}
export const variantPriceHT = (p: Product, variant: Record<string, string>) => (variantField(p, variant, 'priceHT') as number | undefined) ?? p.price_ht
export const variantImage = (p: Product, variant: Record<string, string>) => (variantField(p, variant, 'image') as string | undefined) ?? p.images[0]
export const allImages = (p: Product) => [...new Set([...p.images, ...p.options.flatMap((o) => o.values.map(optionValue).map((v) => v.image).filter(Boolean) as string[])])]

export const plain = (s: string) => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()

export const ORDER_STATUS: Record<string, { label: string; tone: string }> = {
  en_attente: { label: 'En attente de paiement', tone: 'bg-amber-100 text-amber-800' },
  payee: { label: 'Payée', tone: 'bg-emerald-100 text-emerald-800' },
  expediee: { label: 'Expédiée', tone: 'bg-blue-100 text-blue-800' },
  livree: { label: 'Livrée', tone: 'bg-slate-200 text-slate-700' },
  annulee: { label: 'Annulée', tone: 'bg-red-100 text-red-700' },
}
export const QUOTE_STATUS: Record<string, { label: string; tone: string }> = {
  nouveau: { label: 'Reçue', tone: 'bg-amber-100 text-amber-800' },
  en_cours: { label: 'En cours', tone: 'bg-blue-100 text-blue-800' },
  envoye: { label: 'Devis envoyé', tone: 'bg-emerald-100 text-emerald-800' },
  accepte: { label: 'Accepté', tone: 'bg-emerald-200 text-emerald-900' },
  refuse: { label: 'Refusé', tone: 'bg-red-100 text-red-700' },
}
export const PAYMENT_LABEL = { card: 'Carte bancaire', transfer: 'Virement bancaire', mandate: 'Mandat administratif' }

export const COMPANY = { name: 'Carper Sports', phone: '01 86 96 38 06', phoneHref: 'tel:+33186963806', email: 'contact@carpersports.com', city: 'Paris - France' }
